import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import {
  SiteMaintenanceLog,
  siteMaintenanceLogSchema,
} from '@sophocles/entities/SiteMaintenanceLog/siteMaintenanceLogRecord';
import { receiveLimitedUsers } from '@sophocles/entities/User';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* RECEIVE ACTIONS */
export const RECEIVE_SITE_MAINTENANCE_LOGS = 'RECEIVE_SITE_MAINTENANCE_LOGS';
export function receiveSiteMaintenanceLogs(json) {
  return {
    type: RECEIVE_SITE_MAINTENANCE_LOGS,
    siteMaintenanceLogs: mapListToRecords(json, SiteMaintenanceLog),
  };
}

/* REQUEST ACTIONS */
export const REQUEST_SITE_MAINTENANCE_LOGS = 'REQUEST_SITE_MAINTENANCE_LOGS';
function requestSiteMaintenanceLogs(site_id) {
  return {
    type: REQUEST_SITE_MAINTENANCE_LOGS,
    site_id,
  };
}

export const REQUEST_SITE_MAINTENANCE_LOGS_FOR_SITE_GROUP = 'REQUEST_SITE_MAINTENANCE_LOGS_FOR_SITE_GROUP';
function requestSiteMaintenanceLogsForSiteGroup(siteGroup) {
  return {
    type: REQUEST_SITE_MAINTENANCE_LOGS_FOR_SITE_GROUP,
    siteGroup,
  };
}

/* FETCH ACTIONS */
export function fetchSiteMaintenanceLogsForSite(site) {
  return dispatch => {
    dispatch(requestSiteMaintenanceLogs(site));
    return apiClient
      .get(`/sites/${site}/maintenancelogs/`)
      .then(response => normalizeList(response.data.results, 'siteMaintenanceLogs', siteMaintenanceLogSchema))
      .then(json => {
        dispatch(receiveLimitedUsers(json.entities.users));
        return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
      });
  };
}

export function fetchUnresolvedSiteMaintenanceLogsForSite(site) {
  return dispatch => {
    dispatch(requestSiteMaintenanceLogs(site));
    return apiClient
      .get(`/sites/${site}/maintenancelogs/?date_resolved__isnull=True`)
      .then(response => normalizeList(response.data.results, 'siteMaintenanceLogs', siteMaintenanceLogSchema))
      .then(json => {
        dispatch(receiveLimitedUsers(json.entities.users));
        return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
      });
  };
}

export function fetchUnresolvedSiteMaintenanceLogsForSiteGroup(siteGroup) {
  return dispatch => {
    dispatch(requestSiteMaintenanceLogsForSiteGroup(siteGroup));
    return apiClient
      .get(`/sitemaintenancelogs/?date_resolved__isnull=True&site__site_groups__id=${siteGroup}`)
      .then(response => normalizeList(response.data.results, 'siteMaintenanceLogs', siteMaintenanceLogSchema))
      .then(json => {
        dispatch(receiveLimitedUsers(json.entities.users));
        return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
      });
  };
}

export function fetchAllRawSiteMaintenanceLogsForSite(site) {
  return dispatch => {
    dispatch(requestSiteMaintenanceLogsForSiteGroup(site));
    return apiClient.get(`/sitemaintenancelogs/?site__id=${site}`).then(response => fromJS(response.data.results));
  };
}

/* Edit Actions */
export const EDIT_SITE_MAINTENANCE_LOG = 'EDIT_SITE_MAINTENANCE_LOG';
export function editSiteMaintenanceLog(siteMaintenanceLog_id) {
  return {
    type: EDIT_SITE_MAINTENANCE_LOG,
    siteMaintenanceLog: siteMaintenanceLog_id,
  };
}

export function patchSiteMaintenanceLog(siteMaintenanceLog_id, values) {
  return dispatch => {
    dispatch(editSiteMaintenanceLog(siteMaintenanceLog_id));
    return apiClient
      .patch(`/sitemaintenancelogs/${siteMaintenanceLog_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteMaintenanceLogSchema))
      .then(json => {
        dispatch(receiveLimitedUsers(json.entities.users));
        dispatch(
          addToast({
            title: 'Success',
            message: 'Maintenance entry resolved',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
      })
      .catch(error => dispatch(genericErrorAction(error, EDIT_SITE_MAINTENANCE_LOG)));
  };
}

/* Create Actions */
export const CREATE_SITE_MAINTENANCE_LOG = 'CREATE_SITE_MAINTENANCE_LOG';
function sayCreateSiteMaintenanceLog(values) {
  return {
    type: CREATE_SITE_MAINTENANCE_LOG,
    values: values,
  };
}

export function createSiteMaintenanceLog(values) {
  return dispatch => {
    dispatch(sayCreateSiteMaintenanceLog(values));
    return apiClient
      .post(`/sitemaintenancelogs/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, siteMaintenanceLogSchema))
      .then(json => {
        dispatch(receiveLimitedUsers(json.entities.users));
        dispatch(
          addToast({
            title: 'Success',
            message: 'Maintenance entry created',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
      })
      .catch(error => dispatch(genericErrorAction(error, CREATE_SITE_MAINTENANCE_LOG)));
  };
}

const receiver = (dispatch, json) => {
  dispatch(receiveLimitedUsers(json.entities.users));
  return dispatch(receiveSiteMaintenanceLogs(json.entities.siteMaintenanceLogs));
};

export const handleSiteMaintenanceLogSocketActions = websocketsHandlerFactory(
  receiver,
  () => console.log('no deletes'),
  siteMaintenanceLogSchema,
);
